import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AiAgentChatMessage } from './ai-agent-chat-message.models';

@Component({
    selector: 'na-ai-agent-chat-message',
    imports: [MatIconModule, DatePipe],
    templateUrl: './ai-agent-chat-message.component.html',
    styleUrl: './ai-agent-chat-message.component.scss',
})
export class AiAgentChatMessageComponent {
    readonly message = input.required<AiAgentChatMessage>();
}
